import type { RouteRecordRaw } from 'vue-router';
import { adsDashboardGuard, adsFeatureFlagGuard, sepaMandateAdsGuard } from '@bc/advertisement/feature/ads-dashboard/router.guard';

export const routes: RouteRecordRaw[] = [
  {
    path: 'brand-dashboard-ads',
    name: 'brand-dashboard-ads',
    component: () => import('./pages/ads-dashboard.vue'),
    beforeEnter: [adsFeatureFlagGuard, adsDashboardGuard],
  },
  {
    path: 'brand-dashboard-ads-creation',
    name: 'brand-dashboard-ads-creation',
    beforeEnter: [adsFeatureFlagGuard, sepaMandateAdsGuard],
    component: () => import('./pages/campaign-creation-edit.vue'),
  },
  {
    path: 'brand-dashboard-ads-edit/:campaignId',
    name: 'brand-dashboard-ads-edit',
    beforeEnter: [adsFeatureFlagGuard, sepaMandateAdsGuard],
    component: () => import('./pages/campaign-creation-edit.vue'),
  },
  {
    path: 'brand-dashboard-ads/:campaignId',
    name: 'ads-campaign-details',
    component: () => import('./pages/campaign-overview.vue'),
    beforeEnter: adsFeatureFlagGuard,
    props: true,
  },
];
